import type { Journey, JourneyType } from "../../types/journey";
import { IUI_JOURNEY } from "./iui";
import { IUI_JOURNEY_ES } from "./iui-es";
import { IVF_JOURNEY } from "./ivf";
import { IVF_JOURNEY_ES } from "./ivf-es";

export const JOURNEY_FIXTURES: Record<JourneyType, Journey> = {
	ivf: IVF_JOURNEY,
	iui: IUI_JOURNEY,
};

// Locale-specific fixtures. English is the default. Falls back to default
// fixture when a locale-specific one isn't available.
export const JOURNEY_FIXTURES_BY_LOCALE: Record<
	string,
	Partial<Record<JourneyType, Journey>>
> = {
	es: {
		iui: IUI_JOURNEY_ES,
		ivf: IVF_JOURNEY_ES,
	},
};

export function getJourneyFixture(
	type: JourneyType,
	locale: string,
): Journey | undefined {
	const localeMap = JOURNEY_FIXTURES_BY_LOCALE[locale];
	return localeMap?.[type] ?? JOURNEY_FIXTURES[type];
}
